import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { MapNotifier } from './map-notifier';
import { MapState } from './map-state';

@Injectable()
export class MapProvider extends BaseProvider<MapNotifier, MapState> {
  constructor() {
    super(MapNotifier);
    this.trackSessionReset(() => this.notifier.resetViewToInitial());
  }
}
